<div class="content-container">
    <div class="cta-block image-none">
        <h2 class="visually-hidden">Theme footer</h2>
        <div class="cta-block__content">
            <div class="feature-block secondary ">
                <h3>{{ 'Core.Theme.Title' | translate }}</h3>
                <ul class="icon-list ">
                    <li class="hidden"></li>
                    <li><i class="icon-normalphone" aria-hidden="true"></i><a href="tel:{{phone}}">09 210 10 30</a></li>
                    <li><i class="icon-url" aria-hidden="true"></i><a href="{{ 'Core.Contact.Url' | translate }}" target="_blank">{{
                            'Core.Contact.Text' | translate }}</a></li>
                    <li><i class="icon-url" aria-hidden="true"></i><a href="{{ 'Core.Faq.Url' | translate }}">{{
                            'Core.Faq.Text' | translate }}</a></li>
                    <li><i class="icon-user" aria-hidden="true"></i><a href="{{ 'Core.Afspraak.Url' | translate }}" target="_blank">{{
                            'Core.Afspraak.Text' | translate }}</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="footer">
    <h2 class="visually-hidden">Footer</h2>
    <div class="footer-top">
        <div class="content-container">
            <div class="footer--column">
                <div class="gentinfo gentinfo-block dark-background">
                    <div class="gentinfo-block-content">
                        <h3 class="gentinfo-title">Gent<strong>info</strong></h3>
                        <p>{{ 'Core.Footer.Gentinfo.Text' | translate }}</p>

                        <ul class="icon-list inline">
                            <li>
                                <i class="icon-phone" aria-hidden="true"></i>
                                <a href="tel:+3292101010">09 210 10 10</a>
                            </li>
                            <li>
                                <i class="icon-envelope" aria-hidden="true"></i>
                                <a href="mailto:gentinfo@stad.gent">Gentinfo&#64;stad.gent</a>
                            </li>
                            <li>
                                <i class="icon-document" aria-hidden="true"></i>
                                <a href="https://stad.gent/contact" target="_blank">
                                    {{'Core.Footer.Gentinfo.Contactformulier' | translate}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer--column">
                <h3>{{ 'Core.Footer.Links.Title' | translate }}</h3>
                <ul>
                    <li>
                        <a href="https://jobs.gent.be/">{{ 'Core.Footer.Links.Vacancies' | translate }}</a>
                    </li>
                    <li>
                        <a
                            href="https://stad.gent/over-gent-en-het-stadsbestuur/over-gent/kaarten-cijfers-en-data/gent-kaart/stadsplan">{{
                            'Core.Footer.Links.Cityplan' | translate }}</a>
                    </li>
                    <li>
                        <a href="https://persruimte.stad.gent/nl">{{ 'Core.Footer.Links.Pressroom' | translate }}</a>
                    </li>
                </ul>
            </div>
            <div class="footer--column">
                <h3>{{ 'Core.Footer.Social.Text' | translate }}</h3>
                <div class="social-list">
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/stadsbestuurgent">
                                <i aria-hidden="true" class="icon-facebook"></i>
                                <span class="visually-hidden">Facebook</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.twitter.com/stadgent">
                                <i aria-hidden="true" class="icon-twitter"></i>
                                <span class="visually-hidden">Twitter</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/stad-gent">
                                <i aria-hidden="true" class="icon-linkedin"></i>
                                <span class="visually-hidden">LinkedIn</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UCmJLf8SFG0D0GTd6LSSTQLw">
                                <i aria-hidden="true" class="icon-youtube"></i>
                                <span class="visually-hidden">Youtube</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/stadgent/">
                                <i aria-hidden="true" class="icon-instagram"></i>
                                <span class="visually-hidden">Instagram</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom content-container">
        <div class="footer--column">
            <ul>
                <li>
                    <a
                        href="https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/gebruiksvoorwaarden-website-stad-gent">{{
                        'Core.Footer.Links.Legal' | translate }}</a>
                </li>
                <li>
                    <a
                        href="https://stad.gent/nl/over-gent-en-het-stadsbestuur/juridische-info/met-respect-voor-uw-privacy">{{
                        'Core.Footer.Links.Privacy' | translate }}</a>
                </li>
                <li>
                    <a href="https://stad.gent/nl/responsible-disclosure">{{ 'Core.Footer.Links.ResponsibleDisclosure' |
                        translate }}</a>
                </li>
                <li>
                    <a routerLink="/toegankelijkheidsverklaring">{{ 'Core.Footer.Links.Accessibility' | translate }}</a>
                </li>
                <li>
                    <a href="javascript:void(0)" (click)="openCookieSettings()">{{ 'Core.Footer.Links.CookieSettings' | translate }}</a>
                </li>
            </ul>
        </div>
        <div class="footer--column partnership">
            <span>{{ 'Core.Footer.Cooperation' | translate }}</span>
            <i aria-hidden="true" class="icon-district09"></i>
        </div>
    </div>
</section>